export default __webpack_public_path__ + "static/media/footer-standard.cf409c8c.png";